export default __webpack_public_path__ + "static/media/animation-collection.302fd1e0.png";